import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { ModifierDto } from '../dtos';

export class ModifiersState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public modifiers: { [taxrateId: number]: ModifierDto };

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.modifiers = null;
  }
}
